import React, { useEffect, useState } from "react";
import { use } from "react";
import { useNavigate } from "react-router-dom";

export default function SubFilteBotonTodos({
  setVCategoriesSelected = () => {},
  vCategoriesSelected = [],
}) {
  const [vStyle, setVStyle] = useState({});

  const navigate = useNavigate();
  useEffect(() => {
    if (vCategoriesSelected.length === 0) {
      try {
        setVStyle({
          backgroundColor: "#fff",
          color: "#0F172A",
        });
      } catch (error) {
        console.error("Error al parsear el color:", error);
      }
    } else {
      setVStyle({});
    }
  }, [vCategoriesSelected]);

  return (
    <div
      class="filtros"
      style={vStyle}
      onClick={() => {
        setVCategoriesSelected([]);
        navigate(`?f=tcnc`);
      }}
    >
      <p class="filtro-todos-los-cursos-texto">Todos los cursos</p>
    </div>
  );
}
